import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Tab } from "@mui/material";
import * as React from "react";
import withLayout from "../../../hocs/Layout";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import PendingPickups from "./PendingPickups";
import PendingPickupsGrouped from "./PendingPickupsGrouped";
import ManifestList from "./ManifestList";
import BulkManifest from "./BulkManifest";
import PageTitle from "../../../common/PageTitle";
import NestedTabTray from "../../../common/NestedTabTray";
import {
    pageContainerSx,
    tabBarSx, tabContainerSx, tabPanelSx,
} from '../../../styles/patterns';

// `embedded`: rendered as a tab of the Label & Invoices page, which owns the page container
// and page title. In that mode we draw a connector "tray" that visually branches from the
// active parent tab (caretX = that tab's centre, measured & passed by the parent), making it
// obvious these three screens live *inside* Manifest. Standalone mode keeps the plain tab bar.
// `grouped`: Pending Pickups uses the grouped bulk-manifest flow (unrestricted selection,
// server buckets by courier parent x pickup pincode). Piloted on the /pending-pickups route
// only; /labels-invoices renders without it and is unchanged.
function Manifest({ embedded = false, grouped = false, caretX = null, parentColor = '#7c4dff', parentLabel = 'Manifest', parentIcon = <PendingActionsIcon /> }) {
    const [value, setValue] = React.useState("1");
    const handleChange = (_event, newValue) => setValue(newValue);

    const PendingComp = grouped ? PendingPickupsGrouped : PendingPickups;
    const subtabs = [
        { value: "1", label: "Pending Pickups", icon: <PendingActionsIcon />, Comp: PendingComp },
        { value: "2", label: "Manifest List", icon: <LocalShippingOutlinedIcon />, Comp: ManifestList },
        { value: "3", label: "Bulk Upload Manifest", icon: <UploadFileOutlinedIcon />, Comp: BulkManifest },
    ];

    if (embedded) {
        return (
            <NestedTabTray
                caretX={caretX}
                color={parentColor}
                parentLabel={parentLabel}
                parentIcon={parentIcon}
                tabs={subtabs.map(({ value: v, label, icon, Comp }) => ({
                    value: v, label, icon, render: () => <Comp />,
                }))}
            />
        );
    }

    // Standalone route (/pending-pickups etc.) — plain page with the original tab bar.
    return (
        <Box sx={pageContainerSx}>
            <PageTitle subTitle="Manage pending pickups, view generated manifests, and upload bulk manifest files">Manifest & Pickups</PageTitle>

            <TabContext value={value}>
                <Box sx={tabContainerSx}>
                    <TabList onChange={handleChange} sx={tabBarSx}>
                        {subtabs.map((t) => (
                            <Tab key={t.value} icon={React.cloneElement(t.icon, { sx: { fontSize: 16 } })} iconPosition="start" label={t.label} value={t.value} />
                        ))}
                    </TabList>
                    {subtabs.map((t) => {
                        const Body = t.Comp;
                        return (
                            <TabPanel key={t.value} value={t.value} sx={tabPanelSx}>
                                <Body />
                            </TabPanel>
                        );
                    })}
                </Box>
            </TabContext>
        </Box>
    );
}

export default withLayout(Manifest);
